export default {
    root: {
        borderRadius: '10px'
    }
};
